import React, { ComponentType } from 'react';
import {
  RESTRICTION_ERRORS,
} from '../../constants/Errors';
import ShippingRestrictionsAPO from './ShippingRestrictionsAPO';
import { INotification } from '../../application/services/NotificationsService';

export interface IComponentNotificationFactoryProps {
  notification: INotification;
  defaultComponent?: JSX.Element;
}

export interface IComponentNotificationProps {
  notification: INotification;
}

export const shippingAPONotificationsList = [
  RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_MILITARY,
  RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS,
  RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_POBOX,
  RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_TERRITORY,
  RESTRICTION_ERRORS.RESTRICTION_ZIPCODE,
];

export const ComponentsByKey = new Map<ComponentType<IComponentNotificationProps>, string[]>();
ComponentsByKey.set(ShippingRestrictionsAPO, shippingAPONotificationsList);

export const getCustomComponent = (key: string): ComponentType<IComponentNotificationProps> =>
  [...ComponentsByKey.entries()].find(item => item[1].includes(key))?.[0];

export const ComponentNotificationFactory: React.FunctionComponent<IComponentNotificationFactoryProps> =
  ({
    defaultComponent,
    notification,
  }: IComponentNotificationFactoryProps) => {

    const Component = getCustomComponent(notification.key);
    
    return Component ?
      <Component
        notification={notification}
      /> : defaultComponent;
  };
